import React from 'react';
import Button from './Button';
import { Download } from 'lucide-react';
import { useI18n } from '../../context/I18nContext';

interface ExportButtonProps {
  onExport: () => void;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
}

const ExportButton: React.FC<ExportButtonProps> = ({
  onExport,
  className = '',
  disabled = false,
  loading = false
}) => {
  const { t } = useI18n();

  return (
    <Button
      variant="outline"
      onClick={onExport}
      icon={<Download className="w-4 h-4" />}
      className={className}
      disabled={disabled || loading}
      loading={loading}
    >
      {t('common.export')}
    </Button>
  );
};

export default ExportButton;
















